import { AlarmLevel } from "../models/metMap/forecastResult";
import TrendLogic from "./trendLogic";
import GeneralUtil from "../utils/generalUtil";
import _ from "lodash";
class AlarmLogic {
    static worstForecastResult(mpoint, dataType = null) {
        const fResults = Array.from(dataType ? [mpoint.forecastResults.get(dataType)] : mpoint.forecastResults.values())
            .filter(fR => fR && fR.alarmRatio);
        if (fResults.length > 0) {
            const worstRatio = _.max(fResults.map(fr => fr.alarmRatio));
            return fResults.find(fr => fr.alarmRatio === worstRatio);
        }
        return null;
    }
    static worstYearTrend(mpoint, dataType = null) {
        const trends = Array.from(dataType ? [mpoint.trends.get(dataType)] : mpoint.trends.values())
            .filter(t => t && TrendLogic.isShowTrends(mpoint, t.forecastType));
        const now = GeneralUtil.getNow();
        if (trends.length > 0) {
            return _.max(trends.map(t => t.yearResult.alarmRatio));
        }
        return NaN;
    }
    static worstNow(mpoint, dataType = null) {
        let nowVals = Array.from(mpoint.nowValues)
            .filter(v => v);
        if (dataType)
            nowVals = nowVals.filter(v => v[0] === dataType);
        if (nowVals.length > 0) {
            return _.max(nowVals.map(nowVal => nowVal[1].alarmResult.alarmRatio));
        }
        return NaN;
    }
    static worstAlarmRatio(mpoint, dataType = null, withCutoff = true) {
        const worstForecast = AlarmLogic.worstForecastResult(mpoint, dataType);
        const forecastRatio = worstForecast ? worstForecast.alarmRatio : NaN;
        const trendAlarmRatio = AlarmLogic.worstYearTrend(mpoint, dataType);
        const nowAlarmRatio = AlarmLogic.worstNow(mpoint, dataType);
        let alarmRatio = _.max([forecastRatio, trendAlarmRatio, nowAlarmRatio]);
        if (withCutoff)
            alarmRatio = Math.min(1, Math.max(0, alarmRatio));
        return alarmRatio;
    }
    static alarmLevel(ratio) {
        return ratio >= 1 ? AlarmLevel.AboveMax :
            ratio >= AlarmLogic.AlarmRatio_Alarm ? AlarmLevel.Alarm :
                ratio >= AlarmLogic.AlarmRatio_Warning ? AlarmLevel.Warning :
                    AlarmLevel.OK;
    }
}
AlarmLogic.AlarmRatio_AboveMax = NaN;
AlarmLogic.AlarmRatio_Alarm = NaN;
AlarmLogic.AlarmRatio_Warning = NaN;
export default AlarmLogic;
